// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-MainFrame-LeftMenu-LeftMenu-module__leftMenu--tlgr8 {
  height: 100%;
  width: 100%;
  z-index: 999;
  color: #ffffff99;
}
.src-components-MainFrame-LeftMenu-LeftMenu-module__leftMenu--tlgr8 .ant-layout-sider-children {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  justify-content: space-between;
  overflow: hidden;
}
.src-components-MainFrame-LeftMenu-LeftMenu-module__leftMenu--tlgr8 .src-components-MainFrame-LeftMenu-LeftMenu-module__menuContent--JOjyD {
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
}
.src-components-MainFrame-LeftMenu-LeftMenu-module__leftMenu--tlgr8 .src-components-MainFrame-LeftMenu-LeftMenu-module__itemsSection--s4y5O {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
}
.src-components-MainFrame-LeftMenu-LeftMenu-module__leftMenu--tlgr8 .src-components-MainFrame-LeftMenu-LeftMenu-module__logoSection--FFMbe {
  display: flex;
  align-items: center;
  column-gap: 8px;
  padding: 24px;
  color: white;
  font-size: 14px;
  font-weight: 700;
  line-height: 17px;
  letter-spacing: 0em;
  cursor: pointer;
  transition: 0.2s;
}
.src-components-MainFrame-LeftMenu-LeftMenu-module__leftMenu--tlgr8 .src-components-MainFrame-LeftMenu-LeftMenu-module__logoSection--FFMbe svg {
  transition: 0.2s;
}
.src-components-MainFrame-LeftMenu-LeftMenu-module__leftMenu--tlgr8 .src-components-MainFrame-LeftMenu-LeftMenu-module__logoSection--FFMbe:hover,
.src-components-MainFrame-LeftMenu-LeftMenu-module__leftMenu--tlgr8 .src-components-MainFrame-LeftMenu-LeftMenu-module__logoSection--FFMbe:focus-visible {
  color: #f06326;
}
.src-components-MainFrame-LeftMenu-LeftMenu-module__leftMenu--tlgr8 .src-components-MainFrame-LeftMenu-LeftMenu-module__toggledText--MhhO1 {
  opacity: 0;
  transition: 0.2s;
}
.src-components-MainFrame-LeftMenu-LeftMenu-module__leftMenu--tlgr8 .ant-menu-title-content .anticon + .src-components-MainFrame-LeftMenu-LeftMenu-module__menuItemName--Jofhv {
  display: none !important;
}
.src-components-MainFrame-LeftMenu-LeftMenu-module__leftMenu--tlgr8.src-components-MainFrame-LeftMenu-LeftMenu-module__leftMenuActive--xC2RD .src-components-MainFrame-LeftMenu-LeftMenu-module__toggledText--MhhO1 {
  opacity: 1;
}
.src-components-MainFrame-LeftMenu-LeftMenu-module__leftMenu--tlgr8.src-components-MainFrame-LeftMenu-LeftMenu-module__leftMenuActive--xC2RD .anticon + .src-components-MainFrame-LeftMenu-LeftMenu-module__menuItemName--Jofhv {
  display: flex !important;
}
.src-components-MainFrame-LeftMenu-LeftMenu-module__leftMenu--tlgr8 .src-components-MainFrame-LeftMenu-LeftMenu-module__toggleButton--PID5r {
  display: flex;
  align-items: center;
  transition: 0.2s;
  background-color: #343a41;
  border: none;
  color: inherit;
  padding: 14px 24px;
  height: auto;
  width: 100%;
}
.src-components-MainFrame-LeftMenu-LeftMenu-module__leftMenu--tlgr8 .src-components-MainFrame-LeftMenu-LeftMenu-module__toggleButton--PID5r svg {
  width: 20px;
  height: 20px;
  transition: 0.2s;
}
.src-components-MainFrame-LeftMenu-LeftMenu-module__menuItemLabel--m9YlV {
  color: inherit;
  display: flex;
  align-items: center;
  column-gap: 10px;
  height: 100%;
}
.src-components-MainFrame-LeftMenu-LeftMenu-module__menuItemLabel--m9YlV .src-components-MainFrame-LeftMenu-LeftMenu-module__menuItemName--Jofhv {
  margin-inline-start: 0 !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.src-components-MainFrame-LeftMenu-LeftMenu-module__menuItemLabel--m9YlV .anticon {
  display: flex;
  align-items: center;
}
.src-components-MainFrame-LeftMenu-LeftMenu-module__menuItemLabel--m9YlV svg {
  width: 18px;
  height: 18px;
}
.src-components-MainFrame-LeftMenu-LeftMenu-module__bigLink--_YQIK,
.src-components-MainFrame-LeftMenu-LeftMenu-module__bigGroup--LJGJI {
  font-size: 16px;
  font-weight: 500;
}
.src-components-MainFrame-LeftMenu-LeftMenu-module__smallLink--s0qDy {
  font-size: 14px;
  font-weight: 400;
}
.src-components-MainFrame-LeftMenu-LeftMenu-module__smallGroup--ioXFb {
  font-size: 12px;
  font-weight: 400;
  background-color: #282c31;
}
.src-components-MainFrame-LeftMenu-LeftMenu-module__menu--qQ7c5 .ant-menu-item,
.src-components-MainFrame-LeftMenu-LeftMenu-module__menu--qQ7c5 .ant-menu-submenu-title {
  margin: 0;
  width: 100%;
  border-radius: 0;
}
.src-components-MainFrame-LeftMenu-LeftMenu-module__menu--qQ7c5 .ant-menu-submenu-title {
  z-index: 200;
}
.src-components-MainFrame-LeftMenu-LeftMenu-module__menu--qQ7c5 .ant-menu-submenu .ant-menu-submenu-title:has(.src-components-MainFrame-LeftMenu-LeftMenu-module__menuItemLabelActive--E0l4p) {
  background-color: #bd2c003d !important;
}
.src-components-MainFrame-LeftMenu-LeftMenu-module__menu--qQ7c5 .ant-menu-item svg {
  width: 18px;
  height: 18px;
}
.src-components-MainFrame-LeftMenu-LeftMenu-module__menu--qQ7c5 .ant-menu-submenu-title .anticon {
  opacity: 1;
}
.src-components-MainFrame-LeftMenu-LeftMenu-module__menu--qQ7c5 .ant-menu-submenu-title .menuItemName {
  opacity: 0;
}
.src-components-MainFrame-LeftMenu-LeftMenu-module__loaderBox--QZPUe {
  padding: 24px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
:has(.src-components-MainFrame-LeftMenu-LeftMenu-module__leftMenuActive--xC2RD) .ant-menu-submenu-popup {
  opacity: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/MainFrame/LeftMenu/LeftMenu.module.less"],"names":[],"mappings":"AAQA;EACE,YAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AAPF;AAGA;EAOI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;EACA,8BAAA;EACA,gBAAA;AAPJ;AALA;EAgBI,aAAA;EACA,sBAAA;EACA,kBAAA;AARJ;AAVA;EAsBI,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;AATJ;AAhBA;EA6BI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAVJ;AAYI;EACE,gBAAA;AAVN;AAaI;;EAEE,cAAA;AAXN;AApCA;EAoDI,UAAA;EACA,gBAAA;AAbJ;AAgBE;EACE,wBAAA;AAdJ;AAiBE;EAEI,UAAA;AAhBN;AAcE;EAMI,wBAAA;AAjBN;AAjDA;EAuEI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AAnBJ;AAqBI;EACE,WAAA;EACA,YAAA;EACA,gBAAA;AAnBN;AAwBA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;AAtBF;AAwBE;EACE,iCAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAtBJ;AAWA;EAeI,aAAA;EACA,mBAAA;AAvBJ;AA0BE;EACE,WAAA;EACA,YAAA;AAxBJ;AA4BA;;EAEE,eAAA;EACA,gBAAA;AA1BF;AA6BA;EACE,eAAA;EACA,gBAAA;AA3BF;AA8BA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;AA5BF;AA+BA;;EAGI,SAAA;EACA,WAAA;EACA,gBAAA;AA9BJ;AAyBA;EASI,YAAA;AA/BJ;AAsBA;EAaI,sCAAA;AAhCJ;AAmBA;EAiBI,WAAA;EACA,YAAA;AAjCJ;AAeA;EAsBI,UAAA;AAlCJ;AAYA;EA0BI,UAAA;AAnCJ;AAuCA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AArCF;AAwCA;EACE,UAAA;AAtCF","sourcesContent":["@import \"/src/variables.less\";\n\n@menu-bg-color: #464646;\n@menu-item-active-bg-color: #3b3b3b;\n@menu-item-title-color: #c4c4c4;\n@menu-item-active-title-color: #ffffff;\n@menu-active-width: 192px;\n\n.leftMenu {\n  height: 100%;\n  width: 100%;\n  z-index: 999;\n  color: #ffffff99;\n\n  :global(.ant-layout-sider-children) {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    width: 100%;\n    justify-content: space-between;\n    overflow: hidden;\n  }\n\n  .menuContent {\n    display: flex;\n    flex-direction: column;\n    overflow-x: hidden;\n  }\n\n  .itemsSection {\n    display: flex;\n    flex-direction: column;\n    overflow-y: auto;\n    overflow-x: hidden;\n  }\n\n  .logoSection {\n    display: flex;\n    align-items: center;\n    column-gap: 8px;\n    padding: 24px;\n    color: white;\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 17px;\n    letter-spacing: 0em;\n    cursor: pointer;\n    transition: @transition-std;\n\n    & svg {\n      transition: @transition-std;\n    }\n\n    &:hover,\n    &:focus-visible {\n      color: #f06326;\n    }\n  }\n\n  .toggledText {\n    opacity: 0;\n    transition: @transition-std;\n  }\n\n  & :global(.ant-menu-title-content .anticon) + .menuItemName {\n    display: none !important;\n  }\n\n  &.leftMenuActive {\n    .toggledText {\n      opacity: 1;\n    }\n\n    :global(.anticon) + .menuItemName {\n      display: flex !important;\n    }\n  }\n\n  .toggleButton {\n    display: flex;\n    align-items: center;\n    transition: @transition-std;\n    background-color: #343a41;\n    border: none;\n    color: inherit;\n    padding: 14px 24px;\n    height: auto;\n    width: 100%;\n\n    & svg {\n      width: 20px;\n      height: 20px;\n      transition: @transition-std;\n    }\n  }\n}\n\n.menuItemLabel {\n  color: inherit;\n  display: flex;\n  align-items: center;\n  column-gap: 10px;\n  height: 100%;\n\n  & .menuItemName {\n    margin-inline-start: 0 !important;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  :global(.anticon) {\n    display: flex;\n    align-items: center;\n  }\n\n  & svg {\n    width: 18px;\n    height: 18px;\n  }\n}\n\n.bigLink,\n.bigGroup {\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.smallLink {\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.smallGroup {\n  font-size: 12px;\n  font-weight: 400;\n  background-color: #282c31;\n}\n\n.menu {\n  :global(.ant-menu-item),\n  :global(.ant-menu-submenu-title) {\n    margin: 0;\n    width: 100%;\n    border-radius: 0;\n  }\n\n  :global(.ant-menu-submenu-title) {\n    z-index: 200;\n  }\n\n  :global(.ant-menu-submenu .ant-menu-submenu-title):has(.menuItemLabelActive) {\n    background-color: #bd2c003d !important;\n  }\n\n  :global(.ant-menu-item svg) {\n    width: 18px;\n    height: 18px;\n  }\n\n  :global(.ant-menu-submenu-title .anticon) {\n    opacity: 1;\n  }\n\n  :global(.ant-menu-submenu-title .menuItemName) {\n    opacity: 0;\n  }\n}\n\n.loaderBox {\n  padding: 24px;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n:has(.leftMenuActive) :global(.ant-menu-submenu-popup) {\n  opacity: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"leftMenu": `src-components-MainFrame-LeftMenu-LeftMenu-module__leftMenu--tlgr8`,
	"menuContent": `src-components-MainFrame-LeftMenu-LeftMenu-module__menuContent--JOjyD`,
	"itemsSection": `src-components-MainFrame-LeftMenu-LeftMenu-module__itemsSection--s4y5O`,
	"logoSection": `src-components-MainFrame-LeftMenu-LeftMenu-module__logoSection--FFMbe`,
	"toggledText": `src-components-MainFrame-LeftMenu-LeftMenu-module__toggledText--MhhO1`,
	"menuItemName": `src-components-MainFrame-LeftMenu-LeftMenu-module__menuItemName--Jofhv`,
	"leftMenuActive": `src-components-MainFrame-LeftMenu-LeftMenu-module__leftMenuActive--xC2RD`,
	"toggleButton": `src-components-MainFrame-LeftMenu-LeftMenu-module__toggleButton--PID5r`,
	"menuItemLabel": `src-components-MainFrame-LeftMenu-LeftMenu-module__menuItemLabel--m9YlV`,
	"bigLink": `src-components-MainFrame-LeftMenu-LeftMenu-module__bigLink--_YQIK`,
	"bigGroup": `src-components-MainFrame-LeftMenu-LeftMenu-module__bigGroup--LJGJI`,
	"smallLink": `src-components-MainFrame-LeftMenu-LeftMenu-module__smallLink--s0qDy`,
	"smallGroup": `src-components-MainFrame-LeftMenu-LeftMenu-module__smallGroup--ioXFb`,
	"menu": `src-components-MainFrame-LeftMenu-LeftMenu-module__menu--qQ7c5`,
	"menuItemLabelActive": `src-components-MainFrame-LeftMenu-LeftMenu-module__menuItemLabelActive--E0l4p`,
	"loaderBox": `src-components-MainFrame-LeftMenu-LeftMenu-module__loaderBox--QZPUe`
};
export default ___CSS_LOADER_EXPORT___;
